import { objectValuesTyped } from '@bos/utils';
import { z } from 'zod';

import {
	AffectedCampaignTypeRequestV1,
	CampaignStatusV1,
} from '../../../../../api/generated/cz.partners.bank.backofficegateway.campaigns.external';

export const DEFAULT_SPECIFICATION_STATUSES: CampaignStatusV1[] = [
	CampaignStatusV1.ACTIVE,
	CampaignStatusV1.SCHEDULED,
];

export const ALL_SPECIFICATION_STATUSES: CampaignStatusV1[] =
	objectValuesTyped(CampaignStatusV1);

export const DEFAULT_MARKETING_ACTIONS_FILTER_VALUES: MarketingActionsFilterForm =
	{
		affectedSpecificationTypes: [],
		specificationStatuses: DEFAULT_SPECIFICATION_STATUSES,
	};

export const marketingActionsFilterSchema = z.object({
	affectedSpecificationTypes: z
		.enum(AffectedCampaignTypeRequestV1)
		.array()
		.optional(),
	specificationStatuses: z.enum(CampaignStatusV1).array().optional(),
});

export type MarketingActionsFilterForm = z.infer<
	typeof marketingActionsFilterSchema
>;
